import React, { useState } from 'react'
import classNames from 'classnames/bind'
import styles from './Tabs.module.scss'

const cx = classNames.bind(styles)

export interface TabItem {
  id: string
  label: string
  content: React.ReactNode
}

interface TabsProps {
  tabs: TabItem[]
  defaultTab?: string
  activeTab?: string
  onChange?: (id: string) => void
  className?: string
}

export default function Tabs({ tabs, defaultTab, activeTab: controlledTab, onChange, className }: TabsProps) {
  const [internalTab, setInternalTab] = useState<string>(defaultTab ?? tabs[0]?.id ?? '')

  const isControlled = controlledTab !== undefined
  const active = isControlled ? controlledTab : internalTab

  function handleSelect(id: string) {
    if (!isControlled) setInternalTab(id)
    onChange?.(id)
  }

  return (
    <div className={className}>
      <div className={cx('tabs')} role="tablist">
        {tabs.map(tab => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active === tab.id}
            className={cx('tab', { tabActive: active === tab.id })}
            onClick={() => handleSelect(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={cx('tabPanels')}>
        {tabs.map(tab => (
          <div
            key={tab.id}
            role="tabpanel"
            aria-labelledby={tab.id}
            className={cx('tabPanel', { tabPanelActive: active === tab.id })}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  )
}

